import { MainRouteTreeModel } from '@core/models';
import { RouteCodes } from '@core/config/route-codes';

/**
 * albero delle rotte di tutta l'applicazione
 */
export const ROUTES_TREE: {
  [id: string]: MainRouteTreeModel;
} = {
  [RouteCodes.logon]: {
    path: 'logon'
  },
  [RouteCodes.register]: {
    path: 'register',
    children: {
      [RouteCodes.signup]: { path: 'signup' },
      [RouteCodes.passwordRecovery]: { path: 'password-recovery' }
    }
  },
  [RouteCodes.activate]: {
    path: 'activate'
  },
  [RouteCodes.exit]: {
    path: 'exit'
  },
  [RouteCodes.settings]: {
    path: 'settings'
  },
  [RouteCodes.outOfOrder]: {
    path: 'out-of-order'
  },
  [RouteCodes.error]: {
    path: 'error'
  },
  [RouteCodes.dummy]: {
    path: 'dummy'
  },
  [RouteCodes.position]: {
    path: 'position',
    children: {
      [RouteCodes.welcome]: { path: 'welcome' },
      [RouteCodes.summary]: { path: 'summary' },
      [RouteCodes.finish]: { path: 'finish' },
      [RouteCodes.release]: { path: 'release' },
      [RouteCodes.stop]: { path: 'stop' },
      [RouteCodes.quotationCalculate]: { path: 'quotation-calculate' },
      [RouteCodes.quotation]: { path: 'quotation' },
      [RouteCodes.obligations]: { path: 'obligations' },
      [RouteCodes.resolution]: { path: 'delivery-data' },
      [RouteCodes.recognition]: { path: 'recognition' },
      [RouteCodes.consents]: { path: 'consents' },
      [RouteCodes.documentsRequest]: { path: 'documents-request' },
      [RouteCodes.documentsView]: { path: 'documents-view' },
      [RouteCodes.adequacy]: { path: 'adequacy' },
      [RouteCodes.contractSigning]: { path: 'contract-signing' },
      [RouteCodes.customerInfo]: { path: 'customer-info' },
      [RouteCodes.financialData]: { path: 'financial-data' },
      [RouteCodes.notes]: { path: 'notes' },
      [RouteCodes.atcChoice]: { path: 'atc-choice' },
      [RouteCodes.waiting]: { path: 'waiting' },
      [RouteCodes.tfrReleaseQuote]: { path: 'tfr-release-quote' },
      [RouteCodes.cardConfirm]: { path: 'card-confirm' },
      [RouteCodes.usesReport]: { path: 'uses-report' },
      [RouteCodes.dataCollection]: { path: 'data-collection' },
      [RouteCodes.surveyCollection]: { path: 'survey-collection' },
      [RouteCodes.foreigner]: { path: 'foreigner' },
      [RouteCodes.withdraw]: { path: 'withdraw' },
      [RouteCodes.resume]: { path: 'resume' },
      [RouteCodes.instructions]: { path: 'instructions' },
      [RouteCodes.handoverStart]: { path: 'handover-start' },
      [RouteCodes.address]: { path: 'address' },
      [RouteCodes.fundChoice]: { path: 'fund-choice' },
      [RouteCodes.pensionData]: { path: 'pension-data' },
      [RouteCodes.salaryData]: { path: 'salary-data' }
    }
  },
  [RouteCodes.reservedArea]: {
    path: 'reserved-area',
    children: {
      [RouteCodes.dashboard]: {
        path: 'dashboard'
      },
      [RouteCodes.customerData]: {
        path: 'customer-data'
      }
    }
  },
  [RouteCodes.anonymous]: {
    path: 'anonymous',
    children: {
      [RouteCodes.anonymousSimulation]: {
        path: 'simulation'
      },
      [RouteCodes.onboarding]: {
        path: 'onboarding'
      }
    }
  }
};

/**
 * shortcut per le rotte della position
 */
export const POSITION_ROUTES_TREE = {
  ...ROUTES_TREE[RouteCodes.position].children
};

/**
 * shortcut per le rotte dell'area riservata
 */
export const RESERVED_AREA_ROUTES_TREE = {
  ...ROUTES_TREE[RouteCodes.reservedArea].children
};

/**
 * shortcut per le rotte delle pagine anonime
 */
export const ANONYMOUS_ROUTES_TREE = {
  ...ROUTES_TREE[RouteCodes.anonymous].children
};

/**
 * shortcut per le rotte delle pagine di register
 */
export const REGISTER_ROUTES_TREE = {
  ...ROUTES_TREE[RouteCodes.register].children
};
